import { init } from "./draw";
var canvas = (document.getElementById("canvas"));
init(canvas);
